<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" v-on:input="$emit('updateDialog', $event.target.value)" max-width="750px"> 
      <v-card>
        <v-form v-on:submit.prevent="InformarRetraso">
          <v-card-title>
            <span class="headline">Informar Retraso en Operacion {{getOperacion()}}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-12 mt-5">
                <label>Al realizar esta acción se generará una notificacion de retraso a los consignees de la orden que tengasn API configurada, y se actualizará el campo correspondiente con la fecha ingresada.</label>
              </div> 
              <div class="col-md-12">
                <v-combobox
                    v-model="item.field_fecha"
                    data-vv-as="field_fecha"
                    name="field_fecha"
                    item-text="name"
                    item-value="id"
                    :items="fecha_fields"
                    label="Campo de Fecha"
                    autocomplete="off"
                    v-validate="'combobox_required'"                    
                  ></v-combobox>
                  <span class="red--text">{{ errors.first("field_fecha") }}</span> 
              </div>             
              <div class="col-md-12">
                <DatePickerEsp
                  label="Nueva Fecha del Campo"
                  :date="fecha_value"
                  :isRequired="true"
                  name="fecha_value"
                  :isViewModal="false"
                  @setDate="
                    (date) => {
                      fecha_value = date;
                    }
                  "
                />
                <span class="red--text">{{ errors.first("fecha_value") }}</span>                                                
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" :loading="submit_loading" text type="submit">Informar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Constant from "@/constants/";
import { ordersGeneralService } from "@/libs/ws/ordersGeneralService";
import ModalMixin from "@/mixins/ModalMixin.vue";
import DatePickerEsp from "@/components/DatePickerEsp.vue";
export default {
  mixins: [ModalMixin],
  ModalMixin,
  components: {
    DatePickerEsp,
  },
  props: {
    parent: Object,
    order_type: String,     
    dialog: Boolean,
    item: Object,
    updateItem: Function,
    loaloadList: Function,
  },
  data() {
    return {
      show: false,
      fecha_value: null,
      field_fecha: null,
      fecha_fields: [
        /*
        { id: "fecha_recoleccion", name: "Fecha Recoleccion" },//READY_FOR_PICKUP
        { id: "fecha_recoleccion_confirmada", name: "Fecha Recoleccion Confirmada" },//PICKUP_END
        { id: "fecha_salida_etd", name: "Fecha Salida ETD" },//DEPARTURE   
         */     
        { id: "fecha_llegada_eta", name: "Fecha Llegada ETA" },//ARRIV_DESTINATION        
      ]      
    };
  },
  watch: {    
    dialog() {
      this.errors.clear();
    },
  },
  mounted() {        
    
  },
  methods: { 
    getOperacion(){
      return (this.item != null)?this.item.operacion:""
    },
    InformarRetraso(e) {
      if(this.loading)
        return;
      this.setLoading(true);
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();          
          
          const data = {
            id: this.item.id,
            fecha_value: this.fecha_value,
            field_fecha: this.item.field_fecha.id,
            order_type: this.order_type,
          }
          switch(this.order_type){
            case "maritimo":
              ordersGeneralService.setSection(Constant.SECTION_ORDERS_MARITIMAS_COM);    
              break;
            case "terrestre":
              ordersGeneralService.setSection(Constant.SECTION_ORDERS_TERRESTRES_COM);
              break;
            case "aerea":
              ordersGeneralService.setSection(Constant.SECTION_ORDERS);
              break;
          }
          
          ordersGeneralService
            .informarRetraso(data)
            .then((response) => {
              if (response.status == true) {
                this.$toast.success(response.msg, "OK");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                if(Object.prototype.hasOwnProperty.call(response, 'message')){
                  this.$toast.error(response.message, "Error");
                }else{
                  this.$toast.error(response.msg, "Error");
                }
              }
            })
            .catch((response) => {
              this.$toast.error(response.msg, "Error");
            })
            .finally(()=> this.setLoading(false));
          
        }
      });
    },
  },
};
</script>
